import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardMailboxesDetailsDocument,
  type DashboardMailboxesDetailsQuery,
  type DashboardMailboxesDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

export const DASHBOARD_MAILBOXES_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { data } = await client.query<
    DashboardMailboxesDetailsQuery,
    DashboardMailboxesDetailsQueryVariables
  >({
    query: DashboardMailboxesDetailsDocument,
    variables: { id: requireParam(props.params, "id") },
    fetchPolicy: "network-only",
  });

  return data;
};
